// src/components/molecules/NoResults/NoResults.tsx
import { FaSearchMinus } from "react-icons/fa";
import styles from './NoResults.module.scss';
import { useSearchStore } from '../../../../store';

export const NoResults = () => {
    // Obtén el término de búsqueda y la función para limpiar del store
    const { query } = useSearchStore();

    return (
        <div className={styles.container}>
            <FaSearchMinus className={styles.searchIcon} />
            <div className={styles.textWrapper}>
                <p className={styles.mainText}>
                    No encontramos resultados para <span className={styles.searchTerm}>"{query}"</span>.
                </p>
                <p className={styles.subText}>
                    Intenta buscar con otro nombre o palabra clave.
                </p>
            </div>
        </div>
    );
};